import { useContext } from 'react'
import PrinterContext from './context'

export const usePrinter = () => useContext(PrinterContext)
